import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Card.css";
import * as React from "react";
import { Header } from '../../Header';
import { css } from '../../Util';
import { CardContent } from "./CardContent";
import { CustomCard } from "./CustomCard";
export var Card = function (props) {
    var _a = props.titleProps, titleProps = _a === void 0 ? {} : _a, headerClassName = props.headerClassName, headerCommandBarItems = props.headerCommandBarItems, _b = props.headerDescriptionProps, headerDescriptionProps = _b === void 0 ? {} : _b;
    var text = titleProps.text, className = titleProps.className, size = titleProps.size, ariaLevel = titleProps.ariaLevel;
    return (React.createElement(CustomCard, { className: css(props.className, (text || headerCommandBarItems) && "bolt-card-with-header") },
        (text || headerCommandBarItems) && (React.createElement(Header, { className: css(headerClassName, "bolt-card-header"), commandBarItems: headerCommandBarItems, description: headerDescriptionProps.text, descriptionClassName: headerDescriptionProps.className, title: text, titleAriaLevel: ariaLevel, titleClassName: className, titleSize: size })),
        React.createElement(CardContent, tslib_1.__assign({}, props.contentProps), props.children)));
};
